var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/classof-raw.js
// module id = YOqr
// module chunks = 0